import React, {FC, useMemo} from "react";
import {InitiatorName, NotificationHeader, NotificationMessage, ProjectTitle, DivLink} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import {useTranslation} from "react-i18next";

export const NotificationChannel: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const info = actions[0]?.channelCommentInfo;
    const initiator = info?.initiator;
    const { t } = useTranslation()

    const channelName = useMemo(() => info?.teamName , [info])
    const channelId = useMemo(() => info?.teamId , [info])
    const initiatorId = useMemo(() => info?.initiator?.accountId , [info])
    const initiatorName = useMemo(() => `${info?.initiator?.name} ${info?.initiator?.surName}` , [initiator])

    const onExternalLinkClick = () => {
        window.open(CreateLinkTo.designer(initiatorId), '_blank')
    }

    if (!initiator) return null;

    return <NotificationHeader gx={8}>
        <NotificationMessage>
            {' '}
            {t(`notifications.message_add_1`)}
            {' '}
            <span onClick={() => window.open(process.env.REACT_APP_URL_MEDIIIA_COM + '/chat/' + channelId)}>
                <InitiatorName>
                    {channelName}
                </InitiatorName>
            </span>
            {' '}
            {t(`notifications.message_add_2`)}
            {' '}
            <DivLink onClick={onExternalLinkClick}>
                <ProjectTitle>
                    {initiatorName}
                </ProjectTitle>
            </DivLink>
        </NotificationMessage>
    </NotificationHeader>
}import React, {FC, useMemo} from "react";
import {InitiatorName, NotificationHeader, NotificationMessage, ProjectTitle, DivLink} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import {useTranslation} from "react-i18next";

export const NotificationChannel: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const info = actions[0]?.channelCommentInfo;
    const initiator = info?.initiator;
    const { t } = useTranslation()

    const channelName = useMemo(() => info?.teamName , [info])
    const channelId = useMemo(() => info?.teamId , [info])
    const initiatorId = useMemo(() => info?.initiator?.accountId , [info])
    const initiatorName = useMemo(() => `${info?.initiator?.name} ${info?.initiator?.surName}` , [initiator])

    const onExternalLinkClick = () => {
        window.open(CreateLinkTo.designer(initiatorId), '_blank')
    }

    if (!initiator) return null;

    return <NotificationHeader gx={8}>
        <NotificationMessage>
            {' '}
            {t(`notifications.message_add_1`)}
            {' '}
            <span onClick={() => window.open(process.env.REACT_APP_URL_MEDIIIA_COM + '/chat/' + channelId)}>
                <InitiatorName>
                    {channelName}
                </InitiatorName>
            </span>
            {' '}
            {t(`notifications.message_add_2`)}
            {' '}
            <DivLink onClick={onExternalLinkClick}>
                <ProjectTitle>
                    {initiatorName}
                </ProjectTitle>
            </DivLink>
        </NotificationMessage>
    </NotificationHeader>
}